import styles from './SolutionFlat.scss';

import React, { FC, HTMLAttributes } from 'react';
import Slider from 'react-slick';

import { SolutionPickerModule as SolutionPickerModuleType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'src/components/Grid/Grid';
import { GridContainer } from 'src/components/GridContainer/GridContainer';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { SolutionFlatCard } from './SolutionFlatCard';
import { SolutionFlatTitle } from './SolutionFlatTitle';

interface SolutionFlatProps extends HTMLAttributes<HTMLElement> {
  entry?: FlatEntry<SolutionPickerModuleType>;
}

export const SolutionFlat: FC<SolutionFlatProps> = ({
  entry,
}) => {
  if (!entry) return null;
  const { items = [] } = entry;
  const config = {
    className: 'product-mobile-slider',
    dots: false,
    infinite: true,
    speed: 200,
    arrows: false,
    cssEase: 'ease',
    variableWidth: true,
    lazyload: false,
  };

  return (
    <div className={styles.solutionPickerModuleSlider}>
      <GridContainer justifyContent="center">
        <Grid item xs={12}>
          <SolutionFlatTitle entry={entry} />
        </Grid>
      </GridContainer>
      <Grid container xs={12} className={styles.solutionPickerModuleContainer}>
        <Slider {...config} className={styles.solutionPickerModuleProductSlider}>
          {items.map(item => <SolutionFlatCard item={item} key={item.title} />)}
        </Slider>
      </Grid>
    </div>
  );
};
SolutionFlat.displayName = 'SolutionFlat';
